// ** Toolkit imports
import { configureStore } from "@reduxjs/toolkit";

// ** Reducers
import newsReducer from "./news/newsSlice";

export const store = configureStore({
  reducer: {
    news: newsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
